import { render, staticRenderFns } from "./jumpTask.vue?vue&type=template&id=4547689c&scoped=true&"
import script from "./jumpTask.vue?vue&type=script&lang=js&"
export * from "./jumpTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547689c",
  null
  
)

export default component.exports